import {GET_VIDEO_CATEGORIES} from '../../shared/constants/ActionTypes';

const initialState = {
  categories: [],
  total: 0,
};

const videoCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_VIDEO_CATEGORIES:
      return {
        ...state,
        categories: [...action.payload.categories].sort(
          (a, b) => (Number(a.order) || 0) - (Number(b.order) || 0),
        ),
        total: action.payload.total,
      };
    default:
      return state;
  }
};

export default videoCategoryReducer;
